import { combineReducers } from "@reduxjs/toolkit";
import authSlice from "./slices/authSlice";
import inoutSlice from "./slices/inoutSlice";

const rootReducer = combineReducers({
  authSlice,
  inoutSlice,
});

export default rootReducer;
